module.exports = __webpack_public_path__ + "Icono_atras_126px.png";